import { Injectable } from '@angular/core';

import { Observable, pipe } from 'rxjs';
 
@Injectable()
export class LocalStorageService {
  watchData<T>(observable: Observable<T>): void {
    observable.subscribe(this.setObject, console.error);
  }

  get<T>(key: string): T {
    return pipe((k: string) => localStorage.getItem(k), JSON.parse)(key) as T;
  }

  set<T>(key: string, value: T): T {
    localStorage.setItem(key, JSON.stringify(value));
    return value;
  }

  setObject(obj: any) { 
    Object.entries(obj).forEach(([key, value]) => {
      if (obj==null) {
        localStorage.removeItem(key);
      }
      localStorage.setItem(key, JSON.stringify(value));
    });
  }

  clear() {
    localStorage.clear();
  }
}
